import { render, staticRenderFns } from "./pageServices.vue?vue&type=template&id=0bd60040&scoped=true&"
import script from "./pageServices.vue?vue&type=script&lang=js&"
export * from "./pageServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd60040",
  null
  
)

export default component.exports